// Real Seed Audio 1.0 outputs, generated 2026-09-05. Peaks are measured from the audio.
export const SOUND_EFFECT_EXAMPLES = [
  {
    id: 'rain',
    name: 'Rain after dark',
    category: 'Ambience',
    prompt:
      'Close-up rain pattering on a window, a low distant thunder roll, then rain easing off. No speech or music.',
    duration: 8,
    peaks: [
      0, 6, 7, 9, 12, 8, 11, 8, 10, 8, 12, 11, 10, 11, 7, 6, 15, 17, 19, 20, 18,
      30, 35, 23, 36, 75, 63, 64, 83, 75, 100, 49, 20, 20, 27, 23, 35, 26, 21,
      33, 24, 29, 32, 19, 26, 22, 23, 35, 44, 33, 27, 39, 20, 24, 21, 15, 15,
      18, 18, 14, 11, 12, 25, 24, 15, 14, 11, 10, 10, 9, 11, 10, 12, 13, 12, 12,
      9, 7, 7, 0,
    ],
    url: '/audio/seed-audio/rain.mp3',
  },
  {
    id: 'footsteps',
    name: 'Someone at the door',
    category: 'Foley',
    prompt:
      'Slow footsteps on a wooden floor in a quiet room, followed by a door creaking open and gently closing. Close, dry foley recording. No speech or music.',
    duration: 6,
    peaks: [
      0, 4, 3, 2, 3, 13, 66, 22, 17, 13, 4, 4, 3, 3, 3, 3, 3, 100, 40, 36, 20,
      7, 3, 3, 3, 6, 10, 48, 39, 41, 10, 6, 8, 55, 24, 12, 4, 3, 2, 7, 5, 8, 7,
      5, 4, 5, 11, 7, 5, 5, 4, 5, 5, 3, 3, 3, 4, 3, 3, 3, 3, 3, 3, 4, 3, 3, 4,
      4, 3, 3, 3, 12, 50, 17, 8, 5, 3, 3, 2, 0,
    ],
    url: '/audio/seed-audio/footsteps.mp3',
  },
  {
    id: 'spaceship',
    name: 'Ready for liftoff',
    category: 'Sci-fi',
    prompt:
      'A deep spaceship engine hum builds into a bright electronic power-up, then a fast cinematic whoosh trails into silence. No speech or music.',
    duration: 8,
    peaks: [
      0, 28, 29, 37, 32, 49, 37, 45, 42, 50, 43, 31, 30, 28, 42, 43, 48, 61, 94,
      89, 94, 89, 81, 85, 82, 74, 75, 74, 85, 79, 100, 79, 97, 99, 78, 98, 100,
      92, 83, 91, 66, 85, 94, 86, 93, 85, 84, 66, 74, 79, 66, 75, 95, 65, 79,
      59, 59, 72, 71, 73, 65, 55, 53, 44, 33, 27, 19, 17, 12, 14, 11, 7, 4, 3,
      1, 1, 1, 0, 0, 0,
    ],
    url: '/audio/seed-audio/spaceship.mp3',
  },
] as const;
